import { render, staticRenderFns } from "./spike-address-new.vue?vue&type=template&id=fb98efda&scoped=true&"
import script from "./spike-address-new.vue?vue&type=script&lang=js&"
export * from "./spike-address-new.vue?vue&type=script&lang=js&"
import style0 from "./spike-address-new.vue?vue&type=style&index=0&id=fb98efda&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb98efda",
  null
  
)

export default component.exports